<script>
import {onMounted, ref} from "vue";
import axios from "axios";

export default {
    setup() {
        const isHeaderAndFooterEnabled = ref(false);
        const headerHtml = ref(null);
        const footerHtml = ref(null);
        
        function loadHeaderAndFooter() {
            axios.get("/configurations/loadIntranetHeaderAndFooter").then(response => {
                headerHtml.value = response.data[0];
                footerHtml.value = response.data[1];
            });
            
        }
        
        onMounted(() => {
            loadHeaderAndFooter();
        });
        
        return {
            isHeaderAndFooterEnabled,
            headerHtml,
            footerHtml,
        }
    },
    mounted() {
    
    },
    methods: {},
};
</script>

<template>
    <div class="home">
        <div
            ref="customHeader"
            v-if="headerHtml"
            v-html="headerHtml"
        ></div>
        <v-main>
            <router-view/>
        </v-main>
    </div>
</template>